"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var keys_1 = require("./ecc/keys");
var constants_1 = require("./constants");
var types_1 = require("./types");
var utils_1 = require("./utils");
exports.defaultConfig = {
    type: constants_1.DEFAULT_CRYPTOSYSTEM,
    curve: constants_1.DEFAULT_ECC_CURVE,
    rsaSize: constants_1.DEFAULT_RSA_SIZE,
    symmAlg: constants_1.DEFAULT_SYMM_ALG,
    symmLen: constants_1.DEFAULT_SYMM_LEN,
    hashAlg: constants_1.DEFAULT_HASH_ALG,
    charSize: constants_1.DEFAULT_CHAR_SIZE,
    storeName: constants_1.DEFAULT_STORE_NAME,
    readKeyName: constants_1.DEFAULT_READ_KEY_NAME,
    writeKeyName: constants_1.DEFAULT_WRITE_KEY_NAME
};
function normalize(maybeCfg, eccEnabled) {
    if (eccEnabled === void 0) { eccEnabled = true; }
    var cfg;
    if (!maybeCfg) {
        cfg = exports.defaultConfig;
    }
    else {
        cfg = __assign(__assign({}, exports.defaultConfig), maybeCfg);
    }
    if (!(maybeCfg === null || maybeCfg === void 0 ? void 0 : maybeCfg.type)) {
        cfg.type = eccEnabled ? types_1.CryptoSystem.ECC : types_1.CryptoSystem.RSA;
    }
    return cfg;
}
exports.normalize = normalize;
// Attempt a structural clone of an ECC Key (required to store in IndexedDB)
// If it throws an error, use RSA, otherwise use ECC
function eccEnabled() {
    return __awaiter(this, void 0, void 0, function () {
        var keypair, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, keys_1.default.makeKeypair(constants_1.DEFAULT_ECC_CURVE, types_1.KeyUse.Read)];
                case 1:
                    keypair = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, utils_1.default.structuralClone(keypair)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/, true];
            }
        });
    });
}
exports.eccEnabled = eccEnabled;
function merge(cfg, overwrites) {
    if (overwrites === void 0) { overwrites = {}; }
    return __assign(__assign({}, cfg), overwrites);
}
exports.merge = merge;
function symmKeyOpts(cfg) {
    return { alg: cfg.symmAlg, length: cfg.symmLen };
}
exports.symmKeyOpts = symmKeyOpts;
exports.default = {
    defaultConfig: exports.defaultConfig,
    normalize: normalize,
    eccEnabled: eccEnabled,
    merge: merge,
    symmKeyOpts: symmKeyOpts
};
//# sourceMappingURL=config.js.map